import { render, staticRenderFns } from "./DeleteDocumentBtn.vue?vue&type=template&id=5c6ee44f&"
import script from "./DeleteDocumentBtn.js?vue&type=script&lang=js&"
export * from "./DeleteDocumentBtn.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports